export default __webpack_public_path__ + "static/media/close.7ca727dc.png";